/**
 * WEB-928 — кто показывает иконку вкладки на пути воронки.
 *
 * Механизм повторяет funnelPageStyle.ts (WEB-921): на пути воронки пейволл
 * рендерится ВНУТРИ обёрток квиза, поэтому документом владеет PublicQuiz.
 * Встроенный пейволл не лезет в `<head>` сам — он лишь ОБЪЯВЛЯЕТ свою иконку,
 * а владелец страницы решает, показывать её или перебить иконкой квиза (флаг
 * settings.faviconApplyToFunnel). Два компонента, дерущиеся за один
 * `<link rel="icon">`, дали бы гонку с недетерминированным победителем.
 *
 * Отдельно открытый пейволл провайдера над собой не имеет — объявление
 * игнорируется, и он ставит иконку сам.
 */

import { createContext, useContext, useEffect } from 'react';

export type FunnelFaviconSetter = (href: string | null) => void;

/** null = страницу никто не «одалживал» (standalone-режимы). */
export const FunnelFaviconContext = createContext<FunnelFaviconSetter | null>(
  null,
);

/**
 * Объявить иконку на время жизни компонента. Снимается при размонтировании —
 * иначе иконка пейволла осталась бы после возврата к квизу.
 */
export function useDeclareFunnelFavicon(href: string | null): void {
  const setFavicon = useContext(FunnelFaviconContext);

  useEffect(() => {
    if (!setFavicon) return;
    setFavicon(href);
    return () => setFavicon(null);
  }, [setFavicon, href]);
}
